var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.policies.length),expression:"policies.length"}],staticClass:"input-policy",domProps:{"innerHTML":_vm._s(_vm.policiesText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }